
import React, { useEffect, useState, useContext } from "react";
import { getImage, getDataById, minToHours, getTime } from './utils';
import { HoverScrubber } from "./Scrubber";
import { Context } from "../context";




export function MetadataComments(props) {
  const {
    id,
    uniq,
    type,
    author,
    authorImg,
    authorName,
    metaTime,

    commentText,
    typeIcon,
    typeColor,
    typeTitle,
    commentParentId,
    commentParentText,
    videoId,
    handleClick,
  } = { ...props };

  const context = useContext(Context);
  return (
    <>
      <div
        className="p_comment0 p_comment0--slider"
        onClick={() => handleClick(metaTime)}
      >
        <div className="p_comment_time p_comment_time--slider">
          <div className="p_comment_time0 p_comment_time0--slider">
            <div className="p_comment_time_frame p_comment_time_frame--slider">
              <HoverScrubber
                // width={width}
                // height={width * SCREEN_RATIO}
                width={170}
                height={116}
                scrub={false}
                sprite={getDataById(context, "videos", videoId, "sprite")}
                externalSprite={metaTime * 100}
              />
              {/* <img src={getImage(videoThumb)} loading="lazy" sizes="44px" /> */}
            </div>
            <div className="p_comment_time_stamp">
              {
                (getTime(metaTime),
                getDataById(context, "videos", videoId, "length"))
              }
            </div>
          </div>
        </div>
        <div className="p_comment_right p_comment_right--slider">
          <div className="p_comment p_comment--mini">
            <div className="x_comment_title x_comment_title--slider">
              <div className="p_user_ava">
                <img
                  src={getImage(authorImg)}
                  loading="lazy"
                  sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, 16px"
                  className="p_user_ava_img p_user_ava_img--sm"
                />
              </div>
            </div>
          </div>
          <div className="x_comment_text x_comment_text--mini">
            {commentText}
          </div>
        </div>
      </div>
    </>
  );
}
export function MetadataCommentsLine(props) {
  const {
    id,
    uniq,
    type,
    author,
    authorImg,
    authorName,
    metaTime,
    commentText,
    typeIcon,
    typeColor,
    typeTitle,
    commentParentId,
    commentParentText,
    videoId,
    sprite,
  } = { ...props };
  const context = useContext(Context);
  // console.log("authorImg = ", authorImg);

  return (
    <>
      <div className="p_comment0">
        <div className="p_comment_time">
          <div className="p_comment_time0">
            <div className="p_comment_time_frame p_comment_time_frame--mini">
              <HoverScrubber
                // width={width}
                // height={width * SCREEN_RATIO}

                width={170}
                height={116}
                scrub={false}
                sprite={getDataById(context, "videos", videoId, "sprite")}
                externalSprite={metaTime * 100}
              />
            </div>
            <div className="p_comment_time_stamp">
              {
                (getTime(metaTime),
                getDataById(context, "videos", videoId, "length"))
              }
            </div>
          </div>
        </div>
        <div className="p_comment_right">
          <div className="p_comment p_comment--mini">
            <div href="#" className="p_user_details">
              <div>
                <div className="x_user0">
                  <div className="x_user_ava">
                    <img
                      src={getImage(authorImg)}
                      loading="lazy"
                      sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, 16px"
                      className="p_user_ava_img p_user_ava_img--sm"
                    />
                  </div>
                  <h5 className="x_user_name">
                    <span>{authorName}</span>
                    {/* <span className="text-span">Author</span> */}
                  </h5>
                </div>
                <div className="x_comment_text x_comment_text--mini">
                  {commentText}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
